export type ApiState<T> = {
  loading: boolean;
  payload: T;
  successful: boolean;
  error: any;
};

export type ResponseWrapper<T> = {
  message: any;
  status: number;
  success: boolean;
  data: T;
};

export interface CustomResponse {
  message: any;
  status: number;
  success: boolean;
}

export type PaginationType<T> = {
  page: number;
  limit: number;
  count: number;
  rows: T;
};

export const ResetApiState = (payload: any) => ({
  loading: false,
  payload,
  successful: false,
  error: null,
});

export const ResetPaginationState = () => ({
  page: 0,
  limit: 0,
  count: 0,
  rows: [],
});

export const ResetWrappedApiState = (payload: any) => ({
  loading: false,
  payload: { message: payload, success: false, status: 0 },
  successful: false,
  error: null,
});

export const ResetWrappedState = (payload: any) => ({
  message: payload,
  success: false,
  status: 0,
});
